export default "__VITE_ASSET__CrNdesBU__"